import { createContext } from 'react';
import { IdentityProviderContextType } from './identity-provider-types';

export const IdentityProviderContext = createContext<
  IdentityProviderContextType
>(undefined as any);
